/**
 * StufePill — the two stage-coloured pill shapes of the Kontrollbereich:
 *   <SchwelleBadge>  "≥ N Tage" — the list-header threshold badge.
 *   <StufeStatusPill> "Stufe N · M Tage" — the detail-header stage pill.
 * Both use the per-stage soft-badge tokens (cream/orange/salmon/red).
 */

import { cn } from '../../../lib/cn';
import { STUFE_CLASSES } from '../constants';
import type { KontrolleStufe } from '../types';

/** "≥ N Tage" — coloured per stage. */
export function SchwelleBadge({ stufe, schwelleTage }: { stufe: KontrolleStufe; schwelleTage: number }) {
  const c = STUFE_CLASSES[stufe];
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium',
        c.tileBg,
        c.border,
        c.text,
      )}
    >
      ≥ {schwelleTage} Tage
    </span>
  );
}

/** "Stufe N · M Tage" — the detail-header pill, coloured per stage. */
export function StufeStatusPill({ stufe, alterTage }: { stufe: KontrolleStufe; alterTage: number }) {
  const c = STUFE_CLASSES[stufe];
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium',
        c.tileBg,
        c.border,
        c.text,
      )}
    >
      Stufe {stufe} · {alterTage} Tage
    </span>
  );
}
